<template>
  <div>
    <Top @currentMenu="getCurrentMenu"></Top>
    <Left :menu="menu"></Left>
    <div class="right">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Top from "../../components/Top";
import Left from "../../components/Left";
export default {
  name: "layout",
  components: {
    Top,
    Left
  },
  // 路由前回调
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.breadcrumb = to.meta.breadcrumb;
      vm.getSystemNotice();
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.breadcrumb = to.meta.breadcrumb;
    this.getSystemNotice();
    next();
  },
  data() {
    return {
      menu: {},
      breadcrumb: []
    };
  },
  methods: {
    // 获取当前选中的菜单
    getCurrentMenu(item) {
      this.menu = item;
    },
    // 获取系统消息
    getSystemNotice() {
      // this.$notify.info({
      //   title: "消息",
      //   position:"bottom-right",
      //   message: "这是一条消息的提示消息"
      // });
    }
  }
};
</script>

<style scoped>
/* .right {
  position: absolute;
  top: 40px;
  left: 220px;
  right: 0;
  bottom: 0;
  z-index: 0;
} */
</style>